const COMMON_URL = `${process.env.REACT_APP_CLOG_SHARED_SERVICE_ORIGIN_URL}/billing-audit`


const BillingAuditApiUrls = {
  GET: `${COMMON_URL}/get`,
};

export default BillingAuditApiUrls
